/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ArticleDiscrepanciesResponse } from '../models/article-discrepancies-response';
import { ArticleDiscrepancyResponse } from '../models/article-discrepancy-response';
import { deleteArticleDiscrepancy } from '../fn/discrepancies/delete-article-discrepancy';
import { DeleteArticleDiscrepancy$Params } from '../fn/discrepancies/delete-article-discrepancy';
import { getArticleDiscrepanciesForArticle } from '../fn/discrepancies/get-article-discrepancies-for-article';
import { GetArticleDiscrepanciesForArticle$Params } from '../fn/discrepancies/get-article-discrepancies-for-article';
import { getArticleDiscrepancy } from '../fn/discrepancies/get-article-discrepancy';
import { GetArticleDiscrepancy$Params } from '../fn/discrepancies/get-article-discrepancy';
import { patchArticleDiscrepancy } from '../fn/discrepancies/patch-article-discrepancy';
import { PatchArticleDiscrepancy$Params } from '../fn/discrepancies/patch-article-discrepancy';
import { postNewArticleDiscrepancy } from '../fn/discrepancies/post-new-article-discrepancy';
import { PostNewArticleDiscrepancy$Params } from '../fn/discrepancies/post-new-article-discrepancy';
import { putConsigneeArticleDiscrepancies } from '../fn/discrepancies/put-consignee-article-discrepancies';
import { PutConsigneeArticleDiscrepancies$Params } from '../fn/discrepancies/put-consignee-article-discrepancies';

@Injectable({ providedIn: 'root' })
export class DiscrepanciesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `putConsigneeArticleDiscrepancies()` */
  static readonly PutConsigneeArticleDiscrepanciesPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies';

  /**
   * Replace all discrepancies for an article.
   *
   * Replace all discrepancies for an article. And sets the article to checked.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putConsigneeArticleDiscrepancies()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putConsigneeArticleDiscrepancies$Response(params: PutConsigneeArticleDiscrepancies$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepanciesResponse>> {
    const obs = putConsigneeArticleDiscrepancies(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Replace all discrepancies for an article.
   *
   * Replace all discrepancies for an article. And sets the article to checked.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putConsigneeArticleDiscrepancies$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putConsigneeArticleDiscrepancies(params: PutConsigneeArticleDiscrepancies$Params, context?: HttpContext): Observable<ArticleDiscrepanciesResponse> {
    const resp = this.putConsigneeArticleDiscrepancies$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleDiscrepanciesResponse>): ArticleDiscrepanciesResponse => r.body)
    );
  }

  /** Path part for operation `postNewArticleDiscrepancy()` */
  static readonly PostNewArticleDiscrepancyPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies';

  /**
   * Add a new discrepancy to an article.
   *
   * Add a new discrepancy to an article.
   * The delivery note must be in a started checkin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNewArticleDiscrepancy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNewArticleDiscrepancy$Response(params: PostNewArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepancyResponse>> {
    const obs = postNewArticleDiscrepancy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a new discrepancy to an article.
   *
   * Add a new discrepancy to an article.
   * The delivery note must be in a started checkin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNewArticleDiscrepancy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNewArticleDiscrepancy(params: PostNewArticleDiscrepancy$Params, context?: HttpContext): Observable<ArticleDiscrepancyResponse> {
    const resp = this.postNewArticleDiscrepancy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleDiscrepancyResponse>): ArticleDiscrepancyResponse => r.body)
    );
  }

  /** Path part for operation `deleteArticleDiscrepancy()` */
  static readonly DeleteArticleDiscrepancyPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies/{discrepancyKey}';

  /**
   * Delete a discrepancy from a delivery note.
   *
   * Delete a discrepancy from a delivery note.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteArticleDiscrepancy()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteArticleDiscrepancy$Response(params: DeleteArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteArticleDiscrepancy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a discrepancy from a delivery note.
   *
   * Delete a discrepancy from a delivery note.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteArticleDiscrepancy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteArticleDiscrepancy(params: DeleteArticleDiscrepancy$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteArticleDiscrepancy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchArticleDiscrepancy()` */
  static readonly PatchArticleDiscrepancyPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies/{discrepancyKey}';

  /**
   * Update a discrepancy for an article.
   *
   * Update a discrepancy for an article.
   * The delivery note must be in a started checkin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchArticleDiscrepancy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchArticleDiscrepancy$Response(params: PatchArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepancyResponse>> {
    const obs = patchArticleDiscrepancy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a discrepancy for an article.
   *
   * Update a discrepancy for an article.
   * The delivery note must be in a started checkin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchArticleDiscrepancy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchArticleDiscrepancy(params: PatchArticleDiscrepancy$Params, context?: HttpContext): Observable<ArticleDiscrepancyResponse> {
    const resp = this.patchArticleDiscrepancy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleDiscrepancyResponse>): ArticleDiscrepancyResponse => r.body)
    );
  }

  /** Path part for operation `getArticleDiscrepancy()` */
  static readonly GetArticleDiscrepancyPath = '/organization-sites/{organizationSiteKey}/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies/{discrepancyKey}';

  /**
   * Get a discrepancy for an article.
   *
   * Get a discrepancy for an article.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getArticleDiscrepancy()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArticleDiscrepancy$Response(params: GetArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepancyResponse>> {
    const obs = getArticleDiscrepancy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a discrepancy for an article.
   *
   * Get a discrepancy for an article.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getArticleDiscrepancy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArticleDiscrepancy(params: GetArticleDiscrepancy$Params, context?: HttpContext): Observable<ArticleDiscrepancyResponse> {
    const resp = this.getArticleDiscrepancy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleDiscrepancyResponse>): ArticleDiscrepancyResponse => r.body)
    );
  }

  /** Path part for operation `getArticleDiscrepanciesForArticle()` */
  static readonly GetArticleDiscrepanciesForArticlePath = '/organization-sites/{organizationSiteKey}/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/discrepancies';

  /**
   * Get all article discrepancies for an article.
   *
   * Get all article discrepancies for an article.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getArticleDiscrepanciesForArticle()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArticleDiscrepanciesForArticle$Response(params: GetArticleDiscrepanciesForArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleDiscrepanciesResponse>> {
    const obs = getArticleDiscrepanciesForArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all article discrepancies for an article.
   *
   * Get all article discrepancies for an article.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getArticleDiscrepanciesForArticle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArticleDiscrepanciesForArticle(params: GetArticleDiscrepanciesForArticle$Params, context?: HttpContext): Observable<ArticleDiscrepanciesResponse> {
    const resp = this.getArticleDiscrepanciesForArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ArticleDiscrepanciesResponse>): ArticleDiscrepanciesResponse => r.body)
    );
  }

}
